import { ChampionsPage } from '../pages/ChampionsPage';
import { ChampionsSignupPage } from '../pages/ChampionsSignupPage';
import EventsPage from '../pages/EventsPage';
import HomePage from '../pages/HomePage';
import ForumsV2Page from '../pages/forums/ForumsV2Page';
import ForumsV2PostPage from '../pages/forums/ForumsV2PostPage';
import NotFoundPage from '../pages/NotFoundPage';

export const homeRoute = {
  name: 'home',
  path: '/',
  exact: true,
  component: HomePage,
};

export const eventsRoute = {
  name: 'events',
  path: '/events',
  exact: true,
  component: EventsPage,
};

export const championsRoute = {
  name: 'champions',
  path: '/champions',
  exact: true,
  component: ChampionsPage,
};

export const championsSignupRoute = {
  name: 'champions-signup',
  path: '/champions/signup',
  exact: true,
  component: ChampionsSignupPage,
};

export const forumsV2Route = {
  name: 'forumsv2',
  path: '/forumsv2',
  exact: true,
  component: ForumsV2Page,
};

export const forumsV2PostRoute = {
  name: 'forumsv2-post',
  path: '/forumsv2/:slug',
  exact: true,
  component: ForumsV2PostPage,
};

export const notFoundRoute = {
  name: 'not-found',
  path: '*',
  exact: false,
  component: NotFoundPage,
};

const baseRoutes = [homeRoute, eventsRoute, championsSignupRoute, championsRoute, forumsV2Route, forumsV2PostRoute, notFoundRoute];

export const routes = baseRoutes;
